import { render, staticRenderFns } from "./StudentCategoriesForm.vue?vue&type=template&id=30285eec&scoped=true"
import script from "./StudentCategoriesForm.vue?vue&type=script&lang=ts"
export * from "./StudentCategoriesForm.vue?vue&type=script&lang=ts"
import style0 from "./StudentCategoriesForm.vue?vue&type=style&index=0&id=30285eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30285eec",
  null
  
)

export default component.exports